import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { PersonIcon } from '@/shared/ui/display/EmojiIcon';
import useSWR from 'swr';
import { getOperatorById } from '@/entities/operator';
import { fontSize, typography } from '@/shared/theme';

interface OperatorChipProps {
  operatorId: string;
  /** 상위에서 배치 fetch한 경우 전달. 있으면 useSWR 스킵 */
  operator?: { name: string };
}

export function OperatorChip({ operatorId, operator: operatorFromProps }: OperatorChipProps) {
  const { data: operatorFromSwr, isLoading } = useSWR(
    operatorFromProps ? null : operatorId ? ['operator-by-id', operatorId] : null,
    () => getOperatorById(operatorId),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true,
      dedupingInterval: 3600000,
    }
  );

  const operator = operatorFromProps ?? operatorFromSwr;

  if (!operator && isLoading) {
    return (
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        <PersonIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
        <Typography
          component="span"
          sx={{
            fontSize: fontSize.sm,
            color: 'text.secondary',
            fontStyle: 'italic',
          }}
        >
          로딩 중...
        </Typography>
      </Box>
    );
  }

  const label = operator ? `${operator.name} 매니저님` : '알 수 없음';

  return (
    <Chip
      icon={<PersonIcon sx={{ fontSize: 14 }} />}
      label={label}
      size="small"
      variant="outlined"
      sx={{
        height: 22,
        fontSize: fontSize.sm,
        fontWeight: typography.cell.fontWeight,
        '& .MuiChip-icon': {
          marginLeft: 0.5,
          marginRight: 0,
        },
      }}
    />
  );
}
